import { createFileRoute } from "@tanstack/react-router";

import { JoinInviteContainer } from "@/features/invites/containers/join-invite-container";

// Deliberately unguarded. The join page must render for a visitor who is not signed in
// (showing the invitation and a sign-in CTA) as well as for one who is (showing Accept),
// so neither beforeAuthGuard nor beforeGuestGuard applies here.
export const Route = createFileRoute("/join/$token")({
  ssr: false,
  component: JoinInviteContainer,
});
